import Col from "components/ui-elements/Col";
import Row from "components/ui-elements/Row";
import React from "react";

const DataToolbar = (props) => {
  const { tools, ...rest } = props;
  return (
    <Row>
      <Col size={12} className="ml-2 mr-2 mb-2">
        <div className="btn-group">
          {tools &&
            tools.map((item, idx) => {
              const { className, icon, title, label, ...rest } = item;
              const lbl = title ? title : label;
              return (
                <a
                  key={idx}
                  href="#"
                  {...rest}
                  onClick={(event) => {
                    event.preventDefault();
                    item?.onClick?.(event);
                  }}
                  className="btn btn-default btn-md"
                  title={lbl}
                >
                  <i className={"fa  " + icon}></i>&nbsp;{label}
                </a>
              );
            })}
        </div>
      </Col>
    </Row>
  );
};

DataToolbar.defaultProps = {
  tools: null,
};

export default DataToolbar;
